<template>
  <!-- TODO(#111739): 統合フォーマット実装完了時にこの v-if ブロックを削除し v-else 側へ統合 -->
  <v-tooltip
    v-if="featureIsActive('s_type_crawling_pests')"
    top
    :disabled="!(disabled || overlimit || noEventSelected)"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        class="export-excel-button"
        data-testid="export-excel-button-activator"
        v-on="on"
        v-bind="attrs"
      >
        <round-button
          icon="file_download"
          :disabled="isDisabled"
          @click="isDisabled ? null : startUnifiedReportGeneration()"
        >
          <span v-if="!pending">{{ $t('report_download') }}</span>
          <span v-else>{{ $t('pending') }}</span>
        </round-button>
      </div>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
  <!-- トグル OFF 時: 既存 v-menu ツリーをそのまま -->
  <v-menu v-else offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip top :disabled="!(disabled || overlimit || noEventSelected)">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div
            class="export-excel-button"
            data-testid="export-excel-button-activator"
            v-on="tooltipOn"
            v-bind="tooltipAttrs"
          >
            <round-button
              icon="file_download"
              :disabled="isDisabled"
              @click="isDisabled ? null : startReportGeneration()"
            >
              <span v-if="!pending">{{ $t('report_download') }}</span>
              <span v-else>{{ $t('pending') }}</span>
            </round-button>
            <round-button
              :disabled="isDisabled"
              v-bind="attrs"
              v-on="on"
            >
              <v-progress-circular v-if="buttonDisable" indeterminate class="primary--text"></v-progress-circular>
              <span v-else>&#9660;</span>
            </round-button>
          </div>
        </template>
        <span>{{ tooltipText }}</span>
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item link @click="startOldReportGeneration()">
        {{ $t('report_download_old') }}
      </v-list-item>
      <v-list-item
        link
        @click="startAiOpinionReportGeneration()"
      >
        {{ $t('report_download_with_ai_opinion') }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<i18n lang="yaml">
  ja:
    report_download: '報告書を出力'
    report_download_old: '以前の形式で報告書を出力'
    report_download_with_ai_opinion: 'AI所見付き報告書（ベータ）'
    pending: '報告書を出力中'
    tooltip:
      selectRow: '対象データは100件以下にしてください'
      crawlingNotSupported: 'この機能は床置きトラップのデータに対応していません'
      noDataSelected: 'データを選択してください'

  en:
    report_download: 'Report Download'
    report_download_old: 'Old Format (Japanese)'
    report_download_with_ai_opinion: 'Report with AI Findings (Beta)'
    pending: 'Report Downloading'
    tooltip:
      selectRow: 'Report Download cannnot exceed 100 rows.'
      crawlingNotSupported: 'This feature does not support crawling pest data'
      noDataSelected: 'Please select data'
</i18n>

<script>
import { formatISO } from 'date-fns';
import Notifications from '@/mixins/notifications';
import Features from '@/mixins/features';
import RoundButton from '@/components/atoms/RoundButton';

export default {
  name: 'export-excel-button',
  mixins: [Notifications, Features],
  props: {
    events: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RoundButton,
  },
  data() {
    return {
      buttonDisable: false,
    };
  },
  computed: {
    pending() {
      return !!this.$store.getters.getJobId;
    },
    overlimit() {
      return this.events.length > 100;
    },
    noEventSelected() {
      return this.events.length === 0;
    },
    isDisabled() {
      return this.pending || this.buttonDisable || this.disabled || this.overlimit || this.noEventSelected;
    },
    // 暫定: 徘徊性データは段階出荷中のため、本ボタンは徘徊性混在時に disabled としている。
    // Redmine #111068 (S床の報告書を出力できる) 完了時に this.disabled 分岐を削除する。
    tooltipText() {
      if (this.disabled) return this.$t('tooltip.crawlingNotSupported');
      if (this.overlimit) return this.$t('tooltip.selectRow');
      if (this.noEventSelected) return this.$t('tooltip.noDataSelected');
      return '';
    },
  },
  methods: {
    getReportRequestedAtISO() {
      return formatISO(new Date());
    },
    startOldReportGeneration: async function () {
      await this.startReportGeneration({ type: 'legacy' });
    },
    startUnifiedReportGeneration: async function () {
      await this.startReportGeneration({ type: 'unified' });
    },
    startAiOpinionReportGeneration: async function () {
      await this.startReportGeneration({ type: 'with_ai_opinion' });
    },
    startReportGeneration: async function (options) {
      const reportRequestedAtISO = this.getReportRequestedAtISO();

      this.buttonDisable = true;
      const jobId = await this.$store.dispatch('postGenerateReport', {
        events: this.events.map(e => e.id),
        locale: this.$i18n.locale,
        requested_at_iso: reportRequestedAtISO,
        ...(options || { type: 'standard' }),
      });

      this.$store.dispatch('polling', jobId);
      this.buttonDisable = false;
    },
  },
};
</script>

<style scoped lang="sass">
.export-excel-button
  display: inline-flex

  .v-btn
    margin: 0

    &:only-child
      border-radius: 28px

    &:first-child:not(:only-child)
      border-radius: 28px 0 0 28px
      padding-right: 0 !important

    &:last-child:not(:only-child)
      border-radius: 0 28px 28px 0
      min-width: 48px
      padding-left: 0 !important

.v-menu
  display: none

.v-menu__content
  position: absolute

  .v-list
    margin-top: 2px

  .v-list-item
    min-height: 24px
</style>
